// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"300":"7f4996cc","442":"6fcf80af","795":"363fb636"}[chunkId] + ".chunk.js";
};